import { TFunction } from "i18next";
import { Limits } from "~/types/billing";

const translationKeys = {
  live_products: {
    titleWithAbovePlans: "features.live_products.title_with_above",
    title: "features.live_products.title",
    description: "features.live_products.description",
    testimonial: "features.live_products.testimonial",
  },
  paid_plan: {
    titleWithAbovePlans: "features.paid_plan.title_with_above",
    title: "features.paid_plan.title",
    description: "features.paid_plan.description",
    testimonial: "features.paid_plan.testimonial",
  },
  premium_products: {
    titleWithAbovePlans: "features.premium_products.title_with_above",
    title: "features.premium_products.title",
    description: "features.premium_products.description",
    testimonial: "features.premium_products.testimonial",
  },
  winning_products: {
    titleWithAbovePlans: "features.winning_products.title_with_above",
    title: "features.winning_products.title",
    description: "features.winning_products.description",
    testimonial: "features.winning_products.testimonial",
  },
  product_optimizer: {
    titleWithAbovePlans: "features.product_optimizer.title_with_above",
    title: "features.product_optimizer.title",
    description: "features.product_optimizer.description",
    testimonial: "features.product_optimizer.testimonial",
  },
  vip_chat_support: {
    titleWithAbovePlans: "features.vip_chat_support.title_with_above",
    title: "features.vip_chat_support.title",
    description: "features.vip_chat_support.description",
    testimonial: "features.vip_chat_support.testimonial",
  },
} satisfies Record<
  Limits,
  {
    title: string;
    titleWithAbovePlans: string;
    description: string;
    testimonial: string;
  }
>;

export const planEmojis: Record<string, string> = {
  starter: "⭐",
  pro: "✨",
  empire: "👑",
  unicorn: "🦄"
};

export const getFeaturesTranslations = (
  t: TFunction,
  limitType: Limits,
  planName: string,
  hasAbovePlans: boolean
) => {
  const translations = translationKeys[limitType];

  return {
    title: t(
      hasAbovePlans ? translations.titleWithAbovePlans : translations.title,
      { planName }
    ),
    description: t(translations.description, { planName }),
    testimonial: t(translations.testimonial, { planName }),
  };
};
